// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Importa Firestore
import { getAuth, GoogleAuthProvider } from "firebase/auth"; // Importa Auth y GoogleAuthProvider
import { getStorage } from "firebase/storage"; // Importa Storage

// Configuración de Firebase para tu aplicación web
const firebaseConfig = {
  apiKey: "AIzaSyB--8-DwIg9eXbRfcoCFDyO88KZ9G7ty0Q",
  authDomain: "farmacia-a83a3.firebaseapp.com",
  projectId: "farmacia-a83a3",
  storageBucket: "farmacia-a83a3.firebasestorage.app",
  messagingSenderId: "48823140219",
  appId: "1:48823140219:web:66d2c48dc980e2d4d287de",
  measurementId: "G-JR38YLKS03"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Firestore (base de datos)
const db = getFirestore(app);

// Inicializa Auth
const auth = getAuth(app);

// Inicializa Storage
const storage = getStorage(app); // Inicializa Storage

// Configura el proveedor de Google
const googleProvider = new GoogleAuthProvider();

// Exporta las instancias que necesitas
export { db, auth, googleProvider, storage }; // Exporta storage